import { RenderContent } from 'features/help/components/RenderContent/RenderContent';
import { Message } from 'features/help/types/messagingCollection';
import { FC } from 'react';
import { AgentNetConfirmationDialog } from 'ui-kit/components/modal/ConfirmationDialog';
import { UNDERWRITER_PRODUCT_TEST_IDS } from '../feature-details-tabs';

export interface OtherUnderwritersEnableDialogProps {
  open: boolean;
  updateServiceStatus: string;
  acknowledgementMessage?: Message | null;
  onClose: () => void;
  onAccept: () => void | Promise<void>;
}

export const OtherUnderwritersEnableDialog: FC<OtherUnderwritersEnableDialogProps> = ({
  open,
  updateServiceStatus,
  acknowledgementMessage,
  onClose,
  onAccept,
}) => (
  <AgentNetConfirmationDialog
    showDialogActions
    disablePrimaryBtn={updateServiceStatus === 'pending'}
    updatedQAPrefix={{
      close: UNDERWRITER_PRODUCT_TEST_IDS.enableDialog.close,
      cancel: UNDERWRITER_PRODUCT_TEST_IDS.enableDialog.cancel,
      submit: UNDERWRITER_PRODUCT_TEST_IDS.enableDialog.accept,
    }}
    onConfirm={onAccept}
    open={open}
    onDismissAction={onClose}
    dialogTitle="Acknowledgement"
    dialogTitleColor="textPrimary"
    dialogBtnContent="Accept"
    dialogCancelBtnContent="Cancel"
    dialogTextHTML={
      acknowledgementMessage ? <RenderContent document={acknowledgementMessage.messageText} /> : undefined
    }
    dialogText={
      acknowledgementMessage
        ? undefined
        : 'You are enabling this feature for other underwriters. Please review and accept the terms to continue.'
    }
  />
);
